import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Navbar.css";

const Navbar = ({ loggedIn, onLogout, cart }) => {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("cart"); // Clear cart on logout (consistent with App.js)
    onLogout();
    navigate("/");
  };

  const currentPostId = location.pathname.match(/\/post\/(\d+)/);
  const cartItemCount = cart
    ? cart.reduce((sum, item) => sum + item.quantity, 0)
    : 0;

  return (
    <nav className="navbar-container">
      <Link to="/">
        <img
          src="/bonobo-hope-logo.png"
          alt="Bonobo Hope Logo"
          className="navbar-logo"
        />
      </Link>
      <div className={`navbar-links ${showMenu ? "active" : ""}`}>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/KanziCelebration">Celebrate Kanzi!</Link>
          </li>
          <li>
            <Link to="/info">Info</Link>
          </li>
          <li>
            <Link to="/video">Video</Link>
          </li>
          <li>
            <Link to="/donate">Donate</Link>
          </li>
          <li>
            <Link to="/store">Store</Link>
          </li>
          {loggedIn && (
            <>
              <li>
                <Link to="/create-post" className="navbar-button">
                  Create Post
                </Link>
              </li>
              {currentPostId && (
                <li>
                  <Link
                    to={`/edit-post/${currentPostId[1]}`}
                    className="navbar-button"
                  >
                    Edit Post
                  </Link>
                </li>
              )}
              <li>
                <button onClick={handleLogout} className="navbar-logout-button">
                  Logout
                </button>
              </li>
            </>
          )}
          {cartItemCount > 0 && (
            <li className="cart-link">
              <Link to="/cart">
                <i className="fa fa-shopping-cart"></i>
                <span className="cart-count">{cartItemCount}</span>
              </Link>
            </li>
          )}
        </ul>
      </div>
      <div className="navbar-icon" onClick={toggleMenu}>
        <div className={`bar ${showMenu ? "change" : ""}`} />
        <div className={`bar ${showMenu ? "change" : ""}`} />
        <div className={`bar ${showMenu ? "change" : ""}`} />
      </div>
    </nav>
  );
};

export default Navbar;
